import React from 'react';

interface SliderDirectionNavProps {
  handleGotoNext: () => void;
  handleGotoPrev: () => void;
  isTransitioning: boolean;
}

function SliderDirectionNav({
  handleGotoNext,
  handleGotoPrev,
  isTransitioning,
}: SliderDirectionNavProps): React.ReactNode {
  return (
    <ul className="sliderDirectionNav">
      <li className="sliderDirectionNav__item sliderDirectionNav__item--prev">
        <button
          className="sliderDirectionNav__button"
          type="button"
          onClick={handleGotoPrev}
          disabled={isTransitioning}
        >
          Prev
        </button>
      </li>
      <li className="sliderDirectionNav__item sliderDirectionNav__item--next">
        <button
          className="sliderDirectionNav__button"
          type="button"
          onClick={handleGotoNext}
          disabled={isTransitioning}
        >
          Next
        </button>
      </li>
    </ul>
  );
}

export default SliderDirectionNav;
